<template>
  <div id="contenedor-programasinversion-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ProgramasInversionMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
